/*=============================================== CoverPage ===============================================*/

import { Link } from "react-router-dom"
import { Text } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const CoverPage = () => {
    const items: ItemType[] = [
        {
            title: "Center",
            content: (
                <Text>
                    <Link
                        to="/components/cover/demo-center"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Cover\n    src="https://images.unsplash.com/photo-1619360142632-031d811d1678?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1472&q=80"\n    alt="Cover"\n    overlay="black"\n>\n    \n</Cover>',
        },
        {
            title: "Bottom",
            content: (
                <Text>
                    <Link
                        to="/components/cover/demo-bottom"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        Demo here.
                    </Link>
                </Text>
            ),
            code: '<Cover\n    src="https://images.unsplash.com/photo-1619360142632-031d811d1678?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1472&q=80"\n    alt="Cover"\n    overlay="gradient-black"\n    alignItems="flex-start"\n    justifyContent="flex-end"\n>\n    \n</Cover>\n',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "src",
            type: "string",
            required: true,
        },
        {
            subtitle: "alt",
            type: "string",
            required: true,
        },
        {
            subtitle: "overlay",
            type: "string",
            possible: [
                "black",
                "white",
                "gradient-black",
                "gradient-white",
                "none",
            ],
        },
        {
            subtitle: "height",
            type: "string or number",
            default: "100vh",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default CoverPage
